import { CompanyNodeEdge } from '../master/Company/constants';
import { BranchNodeEdge } from '../master/Branch/constants';
import moment from 'moment';

export interface ExpenseEntryFormData<T = ExpenseEntryNodeConnection> {
  id?: string;
  company?: CompanyNodeEdge;
  companyId?: string | null;
  branch?: BranchNodeEdge;
  branchId?: string | null;
  expenseDetails: T;
  date?: string;
}

export interface ExpenseEntryDetailInput {
  date?: string | null;
  expenseId?: string | null;
  amount?: number | null;
  remarks?: string | null;
  companyId?: string | null;
}

export const expenseEntryObject: ExpenseEntryFormData<
  ExpenseEntryDetailInput[]
> = {
  companyId: null,
  branchId: null,
  expenseDetails: [
    {
      date: null,
      expenseId: '',
      amount: 0,
      remarks: '',
      companyId: '',
    },
  ],
  date: moment().format('YYYY-MM-DD'),
};

export interface ExpenseEntryQueryVariable {
  companyId: string;
  branchId?: string | null;
  expenseId?: string;
  after?: string;
}

export interface ExpenseEntryQueryResponse {
  data: {
    allExpenseEntries: {
      edges: ExpenseEntryEdges[];
    };
  };
}

export interface AddExpenseEntryVariable {
  input: {
    expenseEntry: ExpenseEntryFormData<ExpenseEntryDetailInput[]>;
  };
}

export const ExpenseEntryMutation = `
  mutation addExpenseEntry($input: CreateExpenseEntryInput!) {
    createExpenseEntry(input: $input) {
      newExpenseEntry {
        id
        date
      }
    }
  }
`;

export const ExpenseEntryQuery = `
query ExpenseList($companyId: ID!, $expenseId: ID, $after: String, $branchId: ID) {
  allExpenseEntries(companyId: $companyId, branchId: $branchId, first: 20, expenseId: $expenseId, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        date
        amount
        remarks
        expense {
          id
          head
        }
        company {
          id
          name
        }
      }
    }
  }
}
`;

export const SetDefaultExpenseEntryMutation = `
mutation SetDefaultExpenseEntryMutation($input: SetDefaultExpenseEntryInput!) {
  setDefaultExpenseEntry(input: $input) {
    response
  }
}
`;

export const expenseEntryWithDateRangeQuery = `
query ExpenseEntryListWithDateRange($companyId: ID!, $branchId: ID, $startDate: Date!, $date: Date!, $first: Int!, $after: String!, $head: String) {
  allExpenseEntriesDateRange(companyId: $companyId, after: $after, first: $first, branchId: $branchId, startDate: $startDate, endDate: $date, head: $head) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        expense {
          id
          head
        }
        amount
        remarks
        date
        company {
          id
          name
        }
      }
    }
  }
}`;

export interface ExpenseEntryNodeEdge {
  id?: string | null;
  expenseId?: string | null;
  amount?: number | null;
  date?: string | null;
  remarks?: string | null;
  company?: CompanyNodeEdge;
  companyId?: string | null;
  expense?: { id?: string; head?: string } | null;
}

export interface ExpenseEntryEdges {
  cursor?: string;
  node: ExpenseEntryNodeEdge;
}

export interface ExpenseEntryNodeConnection {
  pageInfo: PageInfo;
  edges: ExpenseEntryEdges[];
  totalCount?: number | null;
}

export interface PageInfo {
  endCursor?: string | null;
  hasNextPage: boolean;
  hasPreviousPage?: boolean;
}
